import { render, staticRenderFns } from "./noticeinfo.vue?vue&type=template&id=c970bb56&scoped=true&"
import script from "./noticeinfo.vue?vue&type=script&lang=js&"
export * from "./noticeinfo.vue?vue&type=script&lang=js&"
import style0 from "./noticeinfo.vue?vue&type=style&index=0&id=c970bb56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c970bb56",
  null
  
)

export default component.exports